module.exports = __webpack_public_path__ + "static/img/bg01.023e7416.png";